const { Audio } = window

// TODO load these medias on demand to reduce initial memory usage and delay

export const notif = new Audio('/assets/sounds/ding.mp3')

// CALL
export const outgoingCallAudio = new Audio('/assets/sounds/outgoing_call.mp3')
export const incomingCallAudio = new Audio('/assets/sounds/incoming_call.mp3')
export const callEndedAudio = new Audio('/assets/sounds/call_ended.mp3')

outgoingCallAudio.setAttribute('loop', 'true')
incomingCallAudio.setAttribute('loop', 'true')
